import Mutations from '../../odata/mutations';

export default { ...new Mutations('preferredDeliveryAddress'), ...new Mutations('preferredDeliveryAddresses') };
